"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/sliderSection.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "WELLNESS" | "WISDOM" */
    h20Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h20ClassName?: string;
};
export type HomeSeventeenSliderSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    /** Default: "Play video" */
    sectionDiv1Button0ButtonAriaLabel?: string;
    sectionDiv1Button0ButtonVisible?: boolean;
    sectionDiv1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "service" */
    sectionDiv1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/service/slide-img.jpg" */
    sectionDiv1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sliderSectionServicesSlides: SliderSectionServicesSlidesItem[];
    sliderSectionServicesSlidesItemWrapper?: (item: SliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    sliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH2Visible?: boolean;
    sliderSectionServicesSlidesH2Renderer?: (item: SliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeSeventeenSliderSectionGenerated: FC<HomeSeventeenSliderSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    sectionDiv1Button0ButtonAriaLabel = "Play video",
    sectionDiv1Button0ButtonVisible,
    sectionDiv1Button0ButtonRenderer,
    sectionDiv1Button0ButtonProps,
    sectionDiv1Div0ImageWithBasePath0ImageAlt = "service",
    sectionDiv1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/service/slide-img.jpg",
    sectionDiv1Div0ImageWithBasePath0ImageVisible,
    sectionDiv1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv1Div0ImageWithBasePath0ImageProps,
    divH20H2Props,
    sliderSectionServicesSlides,
    sliderSectionServicesSlidesItemWrapper,
    sliderSectionServicesSlidesRenderer,
    sliderSectionServicesSlidesH2Visible,
    sliderSectionServicesSlidesH2Renderer,
    sliderSectionServicesSlidesH2Props,
}) => {
    return (
        <>
            <section className="slider-section-seventeen p-0 section wow fadeInDown" data-wow-duration={sectionDataWowDuration}>
                <div className="horizontal-slide slide-video d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            sliderSectionServicesSlides,
                            (item: SliderSectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(sliderSectionServicesSlidesH2Visible, sliderSectionServicesSlidesH2Renderer, item, (
                                        <h2 className={item.h20ClassName ?? "title"} {...(typeof sliderSectionServicesSlidesH2Props === "function" ? sliderSectionServicesSlidesH2Props(item) : (sliderSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                    ))}
                                </div>
                            ),
                            sliderSectionServicesSlidesItemWrapper,
                            sliderSectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
                <div className="video-item">
                    <div className="img-overlay">
                        {renderNode(sectionDiv1Div0ImageWithBasePath0ImageVisible, sectionDiv1Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv1Div0ImageWithBasePath0ImageAlt} className="img-fluid wellness-img" {...(sectionDiv1Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv1Button0ButtonVisible, sectionDiv1Button0ButtonRenderer, (
                        <button type="button" className="play-btn" aria-label={sectionDiv1Button0ButtonAriaLabel} onClick={() => onOpenLightbox?.(0)} style={{ background: "none", border: "none", cursor: "pointer" }} {...(sectionDiv1Button0ButtonProps ?? {})}>
                            <i className="isax isax-play"></i>
                        </button>
                    ))}
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSeventeenSliderSectionGenerated;
